import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

/** A 4xx is the server telling us the request is wrong — retrying it just wastes time. */
export function retryUnlessClientError(failureCount: number, error: Error): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: retryUnlessClientError,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
